<p-dropdown [options]="optionsDDL" [placeholder]="placeholder" [formControl]="control" [disabled]="disabled"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue" [styleClass]="styleClass" (onChange)="onSelectionChange($event)"
    (onFilter)="onFilterChange($event)">
</p-dropdown>